<template>
    <div class="item" @click="onPressNav('')">
        <p>{{item.stage_con_name}}</p>
        <div>
            <p>缴费：{{item.money}}元</p>
            <span>{{item.create_time}}</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "billItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
    created() {
        console.log('this', this)
    },
};
</script>
<style lang="less" scoped>
.item {
    margin: 0 15px;
    padding: 10px;
    background: #fff;
    border-bottom: 1px dashed #e1e1e1;

    > p {
        margin-bottom: 10px;
        font-size: 15px;
        color: #333;
    }

    > div {
        display: flex;
        align-items: center;

        p {
            flex: 1;
            font-size: 13px;
            color: #7181EB;
        }

        span {
            font-size: 13px;
            color: #333;
        }
    }
}
</style>